import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: '100%',

    '& .item': {
      '&-avatar': {
        '&-container': {
          background: theme.palette.custom.surface[1],
          color: theme.palette.text.secondary,
        },
      },
      '&-text': {
        '&-container': {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        },
        '&-area': {
          color: theme.palette.text.hint,
        },
      },
      '&-icon-go': {
        color: theme.palette.text.hint,
      },
    },
  },
}));

export default styles;
